import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/dashboard/admin/uno")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/org/uno" });
	},
});
